export const PAGE_ROUTE_LANDING = 'landing';
export const PAGE_ROUTE_LISTING = 'listing';
export const PAGE_ROUTE_COMPARE = 'compare';
export const PAGE_ROUTE_INFO = 'info';
export const PAGE_ROUTE_ALL_NEW_CARS_BRAND = 'all-new-cars-brand';
export const PAGE_ROUTE_PAST_CARS = 'past-cars';
export const PAGE_ROUTE_NEW_CAR_SHOWCASE = 'new-car-showcase';
export const PAGE_ROUTE_BEST_SELLING_CAR_MODELS = 'best-selling-car-models';
export const PAGE_ROUTE_PRICELISTS = 'pricelists';
export const PAGE_ROUTE_AD_PRICELISTS = 'ad-pricelist';
export const PAGE_ROUTE_CONSUMERS_REVIEWS = 'consumers-reviews';
export const PAGE_ROUTE_DEALER_LIST = 'new-car-dealer-list';
export const PAGE_ROUTE_AD_LIST = 'ad-list';
export const PAGE_ROUTE_PI_LIST = 'pi-list';
export const PAGE_PROMOTIONS = 'promotions';
export const PAGE_ROUTE_PARALLEL_IMPORTED_CARS = 'singapore-parallel-imported-cars'; // @suppress longLineCheck
export const PAGE_ROUTE_PARALLEL_IMPORTER_LIST = 'singapore-parallel-importer-list'; // @suppress longLineCheck
export const PAGE_ROUTE_AUTHORISED_DISTRIBUTOR_LIST = 'singapore-authorised-distributor-list'; // @suppress longLineCheck
export const PAGE_ROUTE_PRICELISTS_PI_POPUP = 'pricelists-pi-popup';
export const PAGE_ROUTE_CAR_MODELS = 'car-models';

export const PAGE_NOT_FOUND_TITLE = 'Page Not Found';

export const PAGE_ROUTE_LISTING_SEARCH_OPTION_PLACEHOLDER = 'Search New Cars';

export const PAGE_LAYOUT_BOTTOM_NAV_BAR_ID = 'page-layout-bottom-nav-bar';

export const COOKIE_KEY_DESKTOP_PTO_POPUP_CLOSE_STATUS = 'popupClosed';
export const COOKIE_KEY_DESKTOP_PTO_COUNTER_TIMER = 'ptoCounterTimer';

export const COOKIE_VALUE_DESKTOP_PTO_POPUP_CLOSED = 'true';
export const COOKIE_VALUE_DESKTOP_PTO_COUNTER_TIMER_END = 'true';

export const HASH_ADVANCED_FILTER_POPUP_NAME = 'advanced-search';

export const MODAL_TITLE = 'Report Error In New Car Information';
export const PROCESS_RESULT_TITLE_REPORT_ERROR_SUCCESS = 'Submission Sent!';
export const PROCESS_RESULT_TITLE_REPORT_ERROR_FAIL = 'Error Occurred';
export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_SUCCESS = 'Thank you for bringing the error to our attention.\nRest assured, our team will investigate this matter promptly.'; // @suppress longLineCheck
export const PROCESS_RESULT_MESSAGE_REPORT_ERROR_FAIL = '';
